import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const removeFileFromRegister = api((registerId, workbookIdentifier) =>
    mutate(
        gql`
            mutation RemoveFileFromRegister($registerId: String!, $workbookIdentifier: String!) {
                removeFileFromRegister(registerId: $registerId, workbookIdentifier: $workbookIdentifier)
            }
        `,
        {
            registerId,
            workbookIdentifier,
        },
        { returns: "removeFileFromRegister" }
    )
)
